import React from 'react';
import styled from '@emotion/styled';
import ContentLoader from 'react-content-loader';
import { nafColor } from '@nafcore/theme';

// Mirrors CardBenefitPartner's layout: 353x133 image, right-aligned partner logo, title + ingress.
export const BenefitLoader = () => (
  <Wrapper>
    <ContentLoader
      uniqueKey="article-loader"
      width="100%"
      height="100%"
      viewBox="0 0 353 367"
      preserveAspectRatio="none"
      backgroundColor={nafColor.neutral.neutral1}
      foregroundColor={nafColor.neutral.neutral2}
    >
      <rect x="0" y="0" rx="0" ry="0" width="353" height="133" />
      <rect x="253" y="141" rx="4" ry="4" width="90" height="40" />
      <rect x="24" y="193" rx="3" ry="3" width="180" height="20" />
      <rect x="24" y="225" rx="3" ry="3" width="305" height="16" />
      <rect x="24" y="249" rx="3" ry="3" width="220" height="16" />
    </ContentLoader>
  </Wrapper>
);

const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
  max-width: 353px;
  height: 367px;
  border-radius: 10px;
  border: 1px solid ${nafColor.neutral.neutral1};
`;
